<template>
  <div>
    <BaseTitle :title="$t('content.class_list')" />
    <v-card>
      <div>
        <div class="ml-5 mt-8 mr-5">
          <div class="d-flex align-center justify-space-between pa-2">
            <div>
              <v-btn color="primary" class="btn-primary-custom mb-2 mb-md-0 mr-md-2" @click="dialogClass = true">{{ $t('add') }}</v-btn>
            </div>
            <v-progress-circular class="text-center" v-if="loadingLoad === true" indeterminate color="primary" />
            <div>
              <v-text-field v-model="search" :label="$t('search')" clearable @change="getData">
                <template #prepend-inner>
                  <svg-icon icon="ic-search" class="primary--text mr-3" />
                </template>
              </v-text-field>
            </div>
          </div>
        </div>
        <template v-if="listClass.length">
          <div v-for="(item, index) in listClass" :key="index" class="border-item">
            <v-row>
              <v-col md="1" align="center">
                <div class="mt-5 ml-5">
                  <svg-icon icon="ic_erapor" width="35" height="35" class="primary--text" />
                  <v-divider vertical></v-divider>
                </div>
              </v-col>
              <v-col md="10" class="mt-3">
                <div class="d-block">
                  <h3 class="d-inline">
                    <span class="header-content">{{ item.classroomName }} </span>
                  </h3>
                </div>
                <div class="d-block">
                  <div>
                    <span class="body-content">
                      <span class="mr-3">
                        Year Periode :
                        <strong>{{ item.yearPeriode }}</strong>
                      </span>
                    </span>
                  </div>
                </div>
                <div class="d-flex"></div>
              </v-col>
              <v-col md="1">
                <template>
                  <div class="pa-5">
                    <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <span dark v-bind="attrs" v-on="on">
                          <svg-icon icon="ic-moreaction-black" class="mt-1" />
                        </span>
                      </template>
                      <v-list>
                        <v-list-item>
                          <v-list-item-title class="text-dropdown" @click="viewItem(item.analyticalClassId)">{{ $t('view') }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </template>
              </v-col>
            </v-row>
          </div>
        </template>
        <NoData class="mt-16" v-if="!listClass.length" />
      </div>
    </v-card>
    <!-- Dialog Add -->
    <v-dialog v-model="dialogClass" persistent max-width="800">
      <v-card>
        <v-card-title class="headline secondary white--text d-flex justify-space-between">
          <span>{{ $t('content.add_class') }}</span>
        </v-card-title>
        <v-card-subtitle class="pa-10">
          <v-row>
            <v-col cols="12" md="12" class="py-0">
              <form-group :name="$t('menu.course')" no-gutter :validator="$v.form.classroomId">
                <template slot-scope="{ attrs }">
                  <v-select
                    v-bind="attrs"
                    v-model="form.classroomId"
                    item-value="classroomId"
                    item-text="name"
                    clearable
                    :items="listClassAdd"
                    :label="$t('menu.course')"
                    @input="$v.form.classroomId.$touch()"
                    @blur="$v.form.classroomId.$touch()"
                  />
                </template>
              </form-group>
            </v-col>
          </v-row>
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer />
          <div class="d-flex justify-end align-center mb-2 mr-2">
            <v-btn color="primary" class="btn-primary-custom mr-3" :disabled="loadingAdd" outlined @click="resetAdd">{{ $t('back') }}</v-btn>
            <v-btn color="primary" class="btn-primary-custom" type="submit" :loading="loadingAdd" @click="addClass">{{ $t('submit') }}</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="d-flex justify-end align-center mt-5">
      <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="back">{{ $t('back') }}</v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import NoData from '@/components/table/NoData';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'ListClassAnalitic',
  components: {
    BaseTitle,
    NoData
  },
  props: {
    isClass: {
      type: Boolean,
      default: false
    },
    isStudent: {
      type: Boolean,
      default: false
    },
    isType: {
      type: String,
      default: ''
    }
  },
  validations: {
    form: {
      classroomId: { required }
    }
  },
  sockets: {
    connect() {
      console.log('socket connected');
    },
    updateAnalyticalClass({ schoolId }) {
      const currentschoolId = this.user.schoolId;
      if (schoolId == currentschoolId && this.type === 'teacher') {
        this.$store.dispatch('general/showSuccessNotification', { message: 'Update Analytic Class' });
        setTimeout(() => {
          this.getData();
          this.getDataClass();
        }, 400);
      }
    }
  },
  computed: {
    ...mapGetters({
      classLevel: 'QuizTeacher/classLevel',
      user: 'Auth/user',
      nameCourse: 'CourseList/nameCourse'
    })
  },
  data: () => ({
    dataClass: '',
    listClass: [],
    listClassAdd: [],
    loadingLoad: false,
    loadingAdd: false,
    dialogClass: false,
    titleData: '',
    search: '',
    form: {
      classroomId: ''
    }
  }),
  methods: {
    getData() {
      this.loadingLoad = true;
      this.$store
        .dispatch('Analytical/getListClass', { search: this.search })
        .then(res => {
          this.listClass = res;
        })
        .finally(() => (this.loadingLoad = false));
    },
    getDataClass() {
      this.loadingLoad = true;
      this.$store
        .dispatch('Analytical/getListClassAdd')
        .then(res => {
          this.listClassAdd = res;
        })
        .finally(() => (this.loadingLoad = false));
    },
    resetAdd() {
      this.dialogClass = false;
      this.form.classroomId = '';
      this.$v.$reset();
    },
    addClass() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }
      this.loadingAdd = true;

      this.$store
        .dispatch('Analytical/createClassAnalitic', { ...this.form })
        .then(() => {
          this.getData();
          this.getDataClass();
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => {
          this.$store.dispatch('general/showSuccessNotification', { message: 'Success Import' });
          this.dialogClass = false;
          this.loadingAdd = false;
          this.form.classroomId = '';
          this.$v.$reset();
        });
    },
    viewItem(id) {
      this.$router.push({ name: 'AnalyticClassView', params: { idClass: id } });
    },
    back() {
      this.$router.push({ name: 'MenuListAnalytical' });
    }
  },
  created() {
    this.getData();
    this.getDataClass();
  }
};
</script>

<style lang="scss" scoped>
.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
.body-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}
.header-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 16px;
  width: 133px;
  text-align: left;
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
}
.border-item {
  border-bottom: 1px solid #dedede;
}
</style>
